import { Controller as BaseController } from '@hotwired/stimulus';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default class Controller extends BaseController {
  static values = { presencial: Number, online: Number };

  connect() {
    this.destroyExistingChart();
    var ctx = document.getElementById('presencial-or-online-graph');
    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        datasets: [
          {
            data: [this.presencialValue, this.onlineValue],
            backgroundColor: ['#9BC0C6', '#E06C9B'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          datalabels: {
            display: false, // Desabilita os labels no gráfico de pizza
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  }

  disconnect() {
    this.destroyExistingChart();
  }

  destroyExistingChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
